// src/utils/chatUtils.js

/**
 * Chat utilities for error handling
 */

export const chatUtils = {
  // Get user-friendly error messages
  getErrorMessage(error) {
    const message = error.message || error.toString();
    
    if (error.code === 'ARCHIVE_REQUIRED' || message.includes('30+ days')) {
      return 'You can only delete conversations that have been archived for at least 30 days.';
    }
    
    if (error.code === 'NOT_FOUND' || message.includes('not found')) {
      return 'Conversation not found or you no longer have access to it.';
    }
    
    if (error.code === 'NOT_MEMBER' || message.includes('not a member')) {
      return 'You are not a member of this group or have already left.';
    }
    
    if (message.includes('archived for 30 days')) {
      return 'Conversations must be archived for 30 days before they can be deleted.';
    }
    
    if (message.includes('already left')) {
      return 'You have already left this group.';
    }
    
    // Generic fallback messages
    if (message.includes('delete')) {
      return 'Unable to delete conversation. Please try again later.';
    }
    
    if (message.includes('archive')) {
      return 'Unable to archive conversation. Please try again later.';
    }
    
    if (message.includes('leave')) {
      return 'Unable to leave group. Please try again later.';
    }
    
    return 'An error occurred. Please try again later.';
  }
};